module.exports = __webpack_public_path__ + "img/googlestore@2x.2fe11e96.png";